"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageArgs = exports.encodeBase64Url = exports.getPage = exports.createDefaultStartCursorGenerator = exports.createDefaultEndCursorGenerator = void 0;
function createDefaultEndCursorGenerator(column) {
    return (nodes) => {
        return nodes.length && column ? nodes[nodes.length - 1][`${column}`] : undefined;
    };
}
exports.createDefaultEndCursorGenerator = createDefaultEndCursorGenerator;
function createDefaultStartCursorGenerator(column) {
    return (nodes) => {
        return nodes.length && column ? nodes[0][`${column}`] : undefined;
    };
}
exports.createDefaultStartCursorGenerator = createDefaultStartCursorGenerator;
/**
 * An abstraction which uses a page load function to load nodes and generate a page. itself
 * takes care of some boilerplate code around pagination.
 * @param loadPageFn A function which returns a list of nodes for a given cursor, direction and limit.
 * When direction is backward, the nodes should be sorted descending and ascending otherwise
 * @param args A set of input arguments for the page, in particular cursor and limit using the [after, first]
 * and [before, last] nomenclature.
 * @return a promise of a generic page
 */
async function getPage(loadPageFn, queryParams, headers, args) {
    const isForward = args.first ? true : false;
    const limit = (isForward ? args.first : args.last) ?? 0;
    const startCursor = (isForward ? args.after : args.before) ?? undefined;
    const direction = isForward ? "forward" : "backward";
    const results = await loadPageFn({
        direction,
        numEntries: limit + 1,
        queryParams,
        headers,
        cursor: startCursor,
    });
    const hasMore = results.length > limit;
    const nodes = results.slice(0, limit);
    return {
        nodes,
        hasMore,
        direction,
        queryParams,
        limit,
    };
}
exports.getPage = getPage;
function encodeBase64Url(str) {
    return str ? Buffer.from(str.toString(), "utf8").toString("base64url") : undefined;
}
exports.encodeBase64Url = encodeBase64Url;
function getPageArgs(pageInfo, limit = 50, direction = "forward") {
    let pageArgs;
    if (direction === "forward") {
        pageArgs = {
            first: limit,
            after: pageInfo,
        };
    }
    else {
        pageArgs = {
            last: limit,
            before: pageInfo,
        };
    }
    return pageArgs;
}
exports.getPageArgs = getPageArgs;
//# sourceMappingURL=Pagination.js.map